import Vue from "vue";
import Dialog from "./dialog.vue";

function GenNotification(conponent, msgId) {

  const div = document.createElement("div");
  const el = document.createElement("div");

  div.id = `notification-${msgId}`
  div.appendChild(el);
  document.body.appendChild(div);

  const MsgConstructor = Vue.extend(conponent);
  return propsData => {
    let instance = new MsgConstructor({ propsData }).$mount(el);
    instance.visible = true
    const destroyDialog = () => document.body.removeChild(div)
    return new Promise((resolve) => {
      instance.$once("done", () => {
        /** 我知道了 */
        destroyDialog();
        resolve({ done: true });
      });
      instance.$once("more", () => {
        /** 查看更多 */
        destroyDialog();
        resolve({ more: true })
      });
    });
  };
}

export default function Notify({ msgId, title, tiny, createTime, content, type  }) {
  return GenNotification(Dialog, msgId)({ msgId, title, tiny, createTime, content, type  });
}



// WEBPACK FOOTER //
// ./src/components/notificationBar/dialog.js